export class GetPendingDiscountsListRequest {
    KeywordSearches: string[];
    PageNumber: number;
    ItemsPerPage: number;
    Sorting: number;
    StatusSort: number;
}